<script>
import IntegrationsBase from "@/components/tools/IntegrationsBase.vue";

// import SmartNotifications from "@/components/tools/modals/SmartNotifications";
import Clicksign from "@/components/tools/modals/Clicksign.vue";
import DigitalManagerGuru from "@/components/tools/modals/DigitalManagerGuru.vue";
import FunnelControl from "@/components/tools/modals/FunnelControl.vue";
import Hotzapp from "@/components/tools/modals/Hotzapp.vue";
import Make from "@/components/tools/modals/Make.vue";
import Telegram from "@/components/tools/modals/Telegram.vue";
import Voxuy from "@/components/tools/modals/Voxuy.vue";
import Zapier from "@/components/tools/modals/Zapier.vue";

export default {
  extends: IntegrationsBase,
  data() {
    return {
      name: "Automações",
      subtitle:
        "Integre suas ferramentas de automação à " + this.$config.get("title")
    };
  },
  computed: {
    options() {
      return [
        {
          title: "Voxuy",
          image: require("@/assets/images/integrations/voxuy.svg"),
          description:
            "Integre sua conta da Voxuy à " + this.$config.get("title"),
          modal: Voxuy,
          name: "voxuy"
        },
        {
          title: "Hotzapp",
          image: require("@/assets/images/integrations/hotzapp.svg"),
          description:
            "Integre sua conta da Hotzapp à " + this.$config.get("title"),
          modal: Hotzapp,
          name: "hotzapp"
        },
        {
          title: "Telegram",
          image: require("@/assets/images/integrations/telegram.svg"),
          description:
            "Integre seus chats do Telegram à " + this.$config.get("title"),
          modal: Telegram,
          name: "telegram"
        },
        {
          title: "Make",
          image: require("@/assets/images/integrations/make.svg"),
          description:
            "Integre sua conta da Make à " + this.$config.get("title"),
          modal: Make,
          name: "make"
        },
        {
          title: "Zapier",
          image: require("@/assets/images/integrations/zapier.svg"),
          description:
            "Integre sua conta da Zapier à " + this.$config.get("title"),
          modal: Zapier,
          name: "zapier"
        },
        // {
        //   title: "Notificações Inteligentes",
        //   image: require("@/assets/images/integrations/smart-notifications.svg"),
        //   description:
        //     "Integre sua conta da Notificações Inteligentes à " + this.$config.get('title'),
        //   modal: SmartNotifications,
        //   name: "smart-notifications"
        // },
        {
          title: "Clicksign",
          image: require("@/assets/images/integrations/clicksign.svg"),
          description:
            "Integre sua conta da Clicksign à " + this.$config.get("title"),
          modal: Clicksign,
          name: "clicksign"
        },
        {
          title: "Funnel Control",
          image: require("@/assets/images/integrations/funnel-control.svg"),
          description:
            "Integre sua conta da Funnel Control à " +
            this.$config.get("title"),
          modal: FunnelControl,
          name: "funnel-control"
        },
        {
          title: "Digital Manager Guru",
          image: require("@/assets/images/integrations/digital-manager-guru.svg"),
          description:
            "Integre sua área de membros da plataforma Digital Manager Guru à " +
            this.$config.get("title"),
          modal: DigitalManagerGuru,
          name: "digital-manager-guru"
        }
      ];
    }
  }
};
</script>
